import styled from '@emotion/styled';

export const NoDashlet = styled.div({
  flex: 1,
  cursor: 'pointer',
  margin: '15px',
  span: {
    textAlign: 'left',
    lineHeight: 1.25,
  },
  '.padded-plus': {
    position: 'absolute',
    left: '50%',
    marginLeft: '-1rem',
    top: '50%',
    marginTop: '-1rem',
    color: 'var(--color-button-primary-default)',
  },
  '.padded-plus:hover': {
    color: 'var(--color-button-primary-hover)',
  },
  '.padded-plus:active': {},
});
